export default __webpack_public_path__ + "static/media/ic_send_pc.fa39ffe5.svg";